import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit {

  verifyOtpForm!: FormGroup;
  verified_email!: any;
  emailCheck: any;
  email: string;
  spinner: boolean = false;

  constructor(private fb: FormBuilder, private apiService: ApiServiceService, private spinnerService: NgxSpinnerService,
    private route: ActivatedRoute, private router: Router) {
    this.verifyOtpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });

  }
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] || null;
      console.log(this.email)
      if (!this.email) {
        Swal.fire({
          title: "Error",
          text: "Email not found.",
          icon: "error",
          confirmButtonText: "Okay",
          iconColor: "#FF0000"
        });
      }
    });
  }

  showSpinner(): void {
    this.spinnerService.show();
    setTimeout(() => this.spinnerService.hide(), 1000); // Hide after a delay for demonstration
  }

verifyOtp(): void {
  if (!this.verifyOtpForm.valid) {
    Swal.fire({
      title: "Invalid Input",
      text: "Please enter a valid OTP.",
      icon: "warning",
      confirmButtonText: "Okay",
      iconColor: "#FFA500"
    });
    return;
  }

  const otp = this.verifyOtpForm.get('otp').value;

  if (!this.email) {
    Swal.fire({
      title: "Error",
      text: "Email not found.",
      icon: "error",
      confirmButtonText: "Okay",
      iconColor: "#FF0000"
    });
    return;
  }

  this.spinner = true; // Show spinner
  this.apiService.verifyOtp(this.email, otp).subscribe(
    
    (response: any) => {
      console.log(response)
      this.spinner = false; // Hide spinner
      if (response && response.status === 'success') {
        Swal.fire({
          title: "OTP Verified",
          text: "Redirecting to change password page...",
          icon: "success",
          confirmButtonText: "Okay",
          iconColor: "#00FF00",
          timer: 3000
        }).then(() => {
         this.router.navigate(['/change-password/:email/:token'],{ queryParams: { email: this.email,token:otp } });
        });
      } else {
        Swal.fire({
          title: "Invalid OTP",
          text: response.message || 'The OTP provided is invalid.',
          icon: "error",
          confirmButtonText: "Okay",
          iconColor: "#FF0000"
        });
      }
    },
    error => {
      this.spinner = false; // Hide spinner
      console.error('Error:', error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while verifying OTP.",
        icon: "error",
        confirmButtonText: "Okay",
        iconColor: "#FF0000"
      });
    }
  );
}

onInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  // Remove non-digit characters and limit to 6 digits
  const cleanedValue = value.replace(/\D/g, '').slice(0, 6);

  if (value !== cleanedValue) {
    input.value = cleanedValue; // Update the input value
    this.verifyOtpForm.controls['otp'].setValue(cleanedValue); // Update the form control value
  }
}

}